import { FontAlignmentEnum } from '../../Forms/enums/font-alignment.enum';
import { chartColors } from '../../Charts/enums/chart-colors.enum';
import { LinkDisplayOptionEnum } from '../enums/link-display-option.enum';
import { LinkLayoutOptionEnum } from '../enums/link-layout-option.enum';
import { TextStyleModel } from './text-style.model';
import { StyleStateEnum } from '../enums/style-state.enum';

const defaults = {
    alignment: FontAlignmentEnum.center,
    fontSize: '14px',
    underlined: true,
    iconColor: 'light' as const,
    color: '#000000',
    iconShape: 4, // Second notch from left
    iconSize: 'medium',
    iconBackgroundColor: chartColors.agprBlack,
    displayOption: LinkDisplayOptionEnum.iconOnly,
    layoutOption: LinkLayoutOptionEnum.horizontal,
    styleState: StyleStateEnum.DEFAULT,
};

export class SocialLinkStyleModel extends TextStyleModel {
    iconColor: 'light' | 'dark';
    iconSize: string;
    iconShape: number;
    displayOption: LinkDisplayOptionEnum;
    layoutOption: LinkLayoutOptionEnum;
    iconBackgroundColor: string;

    constructor(apiModel?: any) {
        super(apiModel);
        if (apiModel) {
            this.setFromApiModel(apiModel);
        }
        if (!this.alignment) {
            this.alignment = defaults.alignment;
        }
        if (!this.fontSize) {
            this.fontSize = defaults.fontSize;
        }
        if (!this.underlined) {
            this.underlined = defaults.underlined;
        }
        if (!this.iconColor) {
            this.iconColor = defaults.iconColor;
        }
        if (!this.iconShape) {
            this.iconShape = defaults.iconShape;
        }
        if (!this.iconSize) {
            this.iconSize = defaults.iconSize;
        }
        if (!this.iconBackgroundColor) {
            this.iconBackgroundColor = defaults.iconBackgroundColor;
        }
        if (!this.displayOption && this.displayOption !== 0) {
            this.displayOption = defaults.displayOption;
        }
        if (!this.layoutOption && this.layoutOption !== 0) {
            this.layoutOption = defaults.layoutOption;
        }
        if (!this.color) {
            this.color = defaults.color;
        }

        if (!this.styleState) {
            this.styleState = defaults.styleState;
        }
        if (!this.displayStyleState) {
            this.displayStyleState = this.styleState;
        }
    }


    setFromApiModel(apiModel: any): void {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        if (apiModel.hasOwnProperty('iconColor')) {
            this.iconColor = apiModel.iconColor;
        }

        if (apiModel.hasOwnProperty('iconSize')) {
            this.iconSize = apiModel.iconSize;
        }

        if (apiModel.hasOwnProperty('iconShape')) {
            this.iconShape = apiModel.iconShape;
        }

        if (apiModel.hasOwnProperty('displayOption')) {
            this.displayOption = apiModel.displayOption;
        }

        if (apiModel.hasOwnProperty('layoutOption')) {
            this.layoutOption = apiModel.layoutOption;
        }

        if (apiModel.hasOwnProperty('iconBackgroundColor')) {
            this.iconBackgroundColor = apiModel.iconBackgroundColor;
        }
    }

    protected _toBlockStyleModel(): any {
        return {
            iconColor: this.iconColor,
            iconSize: this.iconSize,
            iconShape: this.iconShape,
            displayOption: this.displayOption,
            layoutOption: this.layoutOption,
            iconBackgroundColor: this.iconBackgroundColor,
            color: this.color,
            backgroundColor: this.backgroundColor,
            fontSize: this.fontSize,
            fontFamily: this.fontFamily,
            bold: this.bold,
            italics: this.italics,
            underlined: this.underlined,
            alignment: this.alignment,
            styleState: this.styleState,
            displayStyleState: this.displayStyleState,
            padding: this.padding
        };
    }

    toApi(): any {
        const apiModel = super.toApi();
        apiModel.iconColor = this.iconColor;
        apiModel.iconSize = this.iconSize;
        apiModel.iconShape = this.iconShape;
        apiModel.displayOption = this.displayOption;
        apiModel.layoutOption = this.layoutOption;
        apiModel.iconBackgroundColor = this.iconBackgroundColor;

        return apiModel;
    }

    clone(): SocialLinkStyleModel {
        const clone = new SocialLinkStyleModel(this._toBlockStyleModel());
        if (this.template) {
            clone.template = this.template.clone();
        }
        return clone;
    }

    equals(other: SocialLinkStyleModel, compareTemplate: boolean): boolean {
        if (!other) {
            return false;
        }


        // If they're both saved styles we don't need to look further
        // @HACK This if condition is complicated because clone isn't used in all places, some use JSON.parse(JSON.stringify(, but it's complicated to update
        // that so for now if other doesn't have isSavedStyle, just check to see that other.styleState is a number, which is equivalent
        if (
            this.isSavedStyle() &&
            (
                (
                    other.hasOwnProperty('isSavedStyle') &&
                    other.isSavedStyle()
                ) ||
                !!Number(other.styleState)
            )
        ) {
            return this.styleState === other.styleState;
        }

        if (!super.equals(other, compareTemplate)) {
            return false;
        }

        if (!super.equals(other, false)) {
            return false;
        }

        if (this.iconColor !== other.iconColor) {
            return false;
        }

        if (this.iconSize !== other.iconSize) {
            return false;
        }

        if (this.iconShape !== other.iconShape) {
            return false;
        }

        if (this.displayOption !== other.displayOption) {
            return false;
        }

        if (this.layoutOption !== other.layoutOption) {
            return false;
        }

        if (this.iconBackgroundColor !== other.iconBackgroundColor) {
            return false;
        }


        return true;
    }

    toBlockStyle(): any {
        if (!this.isSavedStyle()) {
            return this._toBlockStyleModel();
        } else {
            return {
                styleState: this.styleState
            };
        }
    }
}
